export const OOSI_API_URI = process.env.REACT_APP_OOSI_API_URI;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const CDM_URL = process.env.REACT_APP_CDM_URL;

export const DATE_HEADER = ["tca", "entering", "leaving"];

export const NURI = "Nuri";
export const NTU_SAT = "NTU_SAT";
export const KDIC_SAT = "KDIC_SAT";
export const MALAY_SAT = "MALAY_SAT";
export const MALLIGYONG = "Malligyong";

export const NURI_PARAM = {
  INTERVAL: 7 * 24 * 60 * 60 * 1000,
  LIMIT: 20
};

export const HEADER_KEYS = {
  NO: "no",
  CITY: "city",
  NAME: "name",
  SAT_NAME: "satName",
  INTERVAL: "interval",
  ENTERING: "entering",
  LEAVING: "leaving",
  ENTERING_LEAVING: "entering_leaving",
  DURATION: "duration",
  TYPE: "type",
  NORAD_ID: "noradId"
};

export const NURI_HEADER_KEYS = {
  NO: "no",
  PRIMARY: "primaryID",
  SECONDARY: "secondaryID",
  TCA: "tca",
  DCA: "dca"
};

export const ACCESS_TABLE_HEADER = [
  {
    key: HEADER_KEYS.NO,
    label: "No"
  },
  {
    key: HEADER_KEYS.ENTERING,
    label: "Entering"
  },
  {
    key: HEADER_KEYS.LEAVING,
    label: "Leaving"
  },
  {
    key: HEADER_KEYS.DURATION,
    label: "Duration(s)"
  },
  {
    key: HEADER_KEYS.INTERVAL,
    label: "Time to Next Event"
  }
];

export const PROBING_TABLE_HEADER = [
  {
    key: HEADER_KEYS.NO,
    label: "No"
  },
  {
    key: HEADER_KEYS.ENTERING,
    label: "Entering"
  },
  {
    key: HEADER_KEYS.LEAVING,
    label: "Leaving"
  },
  {
    key: HEADER_KEYS.DURATION,
    label: "Duration(s)"
  },
  {
    key: HEADER_KEYS.INTERVAL,
    label: "Time to Next Event"
  }
];

export const NURI_TABLE_HEADER = [
  {
    key: NURI_HEADER_KEYS.NO,
    label: "No"
  },
  {
    key: NURI_HEADER_KEYS.PRIMARY,
    label: "Primary"
  },
  {
    key: NURI_HEADER_KEYS.SECONDARY,
    label: "Secondary"
  },
  {
    key: NURI_HEADER_KEYS.TCA,
    label: "TCA"
  },
  {
    key: NURI_HEADER_KEYS.DCA,
    label: "DCA(km)"
  }
];

export const EVENTS = {
  ACCESS: "Access",
  PROBING: "Probing"
};

export const EVENT_ITEMS = [
  { value: EVENTS.ACCESS, label: "Ground Access" },
  { value: EVENTS.PROBING, label: "Contain Relation" }
];

export const TABLE_HEADER = {
  [EVENTS.ACCESS]: ACCESS_TABLE_HEADER,
  [EVENTS.PROBING]: PROBING_TABLE_HEADER
};
